import { createBrowserRouter } from 'react-router';

import { AuthLogoutPage } from '../pages/AuthLogoutPage';
import { AuthRedirectPage } from '../pages/AuthRedirectPage';
import { DatenschutzPage } from '../pages/Datenschutz/DatenschutzPage';
import { DurchgangDetailsPage } from '../pages/DurchgangDetailsPage/DurchgangDetailsPage.tsx';
import { DurchgangPlanungPage } from '../pages/DurchgangPlanungPage/DurchgangPlanungPage.tsx';
import { FehlerPage } from '../pages/FehlerPage';
import { NotFoundPage } from '../pages/NotFoundPage';
import { RaumRessourcenOverviewPage } from '../pages/RaumRessourcenOverviewPage';
import { SearchPage } from '../pages/SearchPage';
import { ThemaDetailsPage } from '../pages/ThemaDetailsPage';
import { ThemaDetailsRedirectByAkaProduktId } from '../pages/ThemaDetailsPage/ThemaDetailsRedirectByAkaProduktId.tsx';
import { ThemaVeranstaltungPlanungPage } from '../pages/ThemaVeranstaltungPlanungPage';
import { VeranstaltungDetailsPage } from '../pages/VeranstaltungDetailsPage';
import { LayoutWithAuth } from './LayoutWithAuth';
import { RouterError } from './RouterError';
import { PATH } from './url';

export const appRouter = createBrowserRouter([
  {
    path: PATH.AUTH.ROOT,
    errorElement: <RouterError />,
    children: [
      {
        path: PATH.AUTH.LOGOUT,
        Component: AuthLogoutPage,
      },
      {
        path: PATH.AUTH.REDIRECT,
        Component: AuthRedirectPage,
      },
    ],
  },
  {
    path: '/',
    element: <LayoutWithAuth />,
    errorElement: <RouterError />,
    children: [
      {
        Component: FehlerPage,
        path: PATH.FEHLER,
      },
      {
        Component: DatenschutzPage,
        path: PATH.DATENSCHUTZ,
      },
      {
        Component: RaumRessourcenOverviewPage,
        path: PATH.RAUM_RESSOURCEN_UEBERSICHT,
      },
      {
        Component: SearchPage,
        index: true,
      },
      {
        Component: ThemaDetailsPage,
        path: PATH.THEMA.DETAILS,
      },
      {
        Component: ThemaDetailsRedirectByAkaProduktId,
        path: PATH.THEMA.DETAILS_REDIRECT_BY_AKA_PRODUKT_ID,
      },
      {
        Component: ThemaVeranstaltungPlanungPage,
        path: PATH.THEMA.VERANSTALTUNG_PLANUNG,
      },
      {
        Component: DurchgangPlanungPage,
        path: PATH.THEMA.DURCHGANG_PLANUNG,
      },
      {
        Component: VeranstaltungDetailsPage,
        path: PATH.VERANSTALTUNG.DETAILS,
      },
      {
        Component: DurchgangDetailsPage,
        path: PATH.DURCHGANG.DETAILS,
      },
      {
        Component: NotFoundPage,
        path: PATH.NOT_FOUND,
      },
    ],
  },
]);
